import React, { useEffect } from "react";

// scss
import "./assets/scss/theme.scss";

//Route
import Routes from "./routes";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// api config
// import config from "./config";
// import fakeBackend from "./helpers/fakeBackend";

// TODO
// fakeBackend();

// const firebaseConfig = {
//   apiKey: config.FIRE_BASE.API_KEY,
//   authDomain: config.FIRE_BASE.AUTH_DOMAIN,
//   databaseURL: config.FIRE_BASE.DATABASEURL,
//   projectId: config.FIRE_BASE.PROJECTID,
//   storageBucket: config.FIRE_BASE.STORAGEBUCKET,
//   messagingSenderId: config.FIRE_BASE.MESSAGINGSENDERID,
//   appId: config.FIRE_BASE.APPID,
//   measurementId: config.FIRE_BASE.MEASUREMENTID,
// };

// // init firebase backend
// initFirebaseBackend(firebaseConfig);

export const requestSoundPermission = () => {
  const audio = new Audio("/sounds/notify.mp3");
  audio.muted = true;
  audio.play().then(() => {
    audio.pause();
    audio.muted = false;
    // console.log("Som liberado");
  }).catch(() => {
    console.log("Usuário precisa clicar na tela para liberar som");
  });
};

const App = () => {
  useEffect(() => {
    requestSoundPermission();
  }, []);

  document.title = "ZConnect - RW Consultoria"

  return <Routes future={{
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }} />;
};

export default App;
